import * as React from "react";
import { useEffect, useRef } from "react";
import {
  IconDotsVertical,
  IconDownload,
  IconNoteOff,
  IconPlus,
  IconSearch,
  IconSend,
  IconX,
} from "@tabler/icons-react";
import "./tab.component.css";
import "./dialog.css";
import {
  Avatar,
  Button,
  Flex,
  Grid,
  Group,
  Menu,
  Select,
  Textarea,
  rem,
  Text,
} from "@mantine/core";
import PdfOnlyViewer from "../Flow-step/PdfOnlyViewer";

const TaskProcess = () => {

  return (
    <>
      <Grid grow>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <Flex
            gap="xs"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Select
              //  label="Your favorite library"
              placeholder="Pick value"
              data={["React", "Angular", "Vue", "Svelte"]}
            />
            <Button
              leftSection={<IconSearch size={14} />}
              color="teal"
              variant="outline"
            >
              Kiểm tra chữ ký số
            </Button>
          </Flex>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          {" "}
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconPlus size={14} />}
              color=""
              variant="outline"
            >
              Ký ảnh
            </Button>
            <Button
              leftSection={<IconNoteOff size={14} />}
              color="orange"
              variant="outline"
            >
              Từ chối
            </Button>

            <Menu shadow="md" trigger="hover" openDelay={100} closeDelay={200}>
              <Menu.Target>
                <Button
                  rightSection={<IconDotsVertical size={14} />}
                  color="violet"
                  variant="outline"
                >
                  Thao tác khác
                </Button>
              </Menu.Target>

              <Menu.Dropdown style={{ fontSize: "20px" }}>
                <Menu.Item
                  leftSection={
                    <IconX style={{ width: rem(30), height: rem(30) }} />
                  }
                  style={{ fontSize: "15px" }}
                  onClick={() => { }}
                >
                  Đóng
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconDownload style={{ width: rem(30), height: rem(30) }} />
                  }
                  style={{ fontSize: "15px" }}
                >
                  DownLoad
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Grid.Col>
      </Grid>

      <Grid grow>
        <Grid.Col span={{ base: 12, sm: 7, md: 8 }}>
          <div className="e-card" id="weather_card">
            <PdfOnlyViewer files="" />
          </div>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 5, md: 4 }}>
          <div className="e-card" id="weather_card">
            <div className="e-card-header">
              <div className="e-card-header-caption">
                <div className="e-card-header-title e-card-3">
                  Chi tiết trao đổi
                </div>
                <Grid>
                  <Grid.Col span={{ base: 2 }}>1</Grid.Col>
                  <Grid.Col span={{ base: 10 }}>
                    {" "}
                    <div style={{ marginTop: "30px" }}>
                      <Group>
                        <Avatar
                          src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png"
                          alt="Jacob Warnhalter"
                          radius="xl"
                        />
                        <div>
                          <Text size="sm">Nguyễn Khả Hợp</Text>
                          <Text size="xs" c="dimmed">
                            10 phút trước
                          </Text>
                        </div>
                      </Group>
                      <Text pl={54} pt="sm" size="sm">
                        This Pokémon likes to lick its palms that are sweetened
                        by being soaked in honey. Teddiursa concocts its own
                        honey by blending fruits and pollen collected by
                        Beedrill. Blastoise has water spouts that protrude from
                        its shell. The water spouts are very accurate.
                      </Text>
                    </div>
                  </Grid.Col>
                </Grid>

                <Grid mt={"50px"} align="center">
                  <Grid.Col span={{ base: 10 }}>
                    {" "}
                    <Textarea
                      //  label="Input label"
                      //  description="Viết comment"
                      placeholder="Viết comment"
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 2 }}>
                    {" "}
                    <IconSend size={"39px"} color="#228be6" />
                  </Grid.Col>
                </Grid>
              </div>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </>
  );
};
export default TaskProcess;
